<p-panel>
  <p-header>
    <span>
      <i class="fas fa-key" aria-hidden="true"></i> {{'UserPrefs.password.change' | translate}}</span>
  </p-header>
  <div class="container">
    <div class="row">
      <form (ngSubmit)="updatePassword()">
        <div class="ui-widget-content p-xxs">
          <span>{{ 'UserPrefs.password.old' | translate }}</span>
        </div>
        <div class="ui-widget-content p-xxs">
          <input pInputText id="passOld" name="passOld" [ngModelOptions]="{ standalone: true }" [(ngModel)]="passOld"
            type="password" autocomplete="new-password" tabindex="1" (ngModelChange)="isValidPassword()">
        </div>
        <div class="ui-widget-content p-xxs">
          <span>{{ 'UserPrefs.password.new' | translate }}</span>
        </div>
        <div class="ui-widget-content p-xxs">
          <input pInputText id="passNew" name="passNew" [ngModelOptions]="{ standalone: true }" [(ngModel)]="passNew"
            type="password" autocomplete="new-password" tabindex="2" (ngModelChange)="calculatePasswordStrength()">
        </div>
        <div class="ui-widget-content p-xxs">
          <span>{{ 'LoginView.passwordConfirm' | translate }}</span>
        </div>
        <div class="ui-widget-content p-xxs">
          <input pInputText id="passConfirm" name="passConfirm" [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="passConfirm" type="password" autocomplete="new-password" tabindex="3"
            (ngModelChange)="calculatePasswordStrength()">
        </div>
        <div class="alert alert-danger" *ngIf="!isValidPassword() && passNew && passConfirm">
          <ul class="pl-3">
            <li *ngIf="!passOld">
              {{'LoginView.change.old' | translate}}</li>
            <li *ngIf="passNew !== passConfirm">
              {{'LoginView.different' | translate}}</li>
            <li *ngIf="passOld && passNew === passOld">
              {{'LoginView.same' | translate}}</li>
            <li *ngIf="passNew == passConfirm && this.strengthErrorMsg">{{this.strengthErrorMsg}}</li>
          </ul>
        </div>
        <div class="ui-widget-content p-h-xs">
          <button type="button" pButton type="button" icon="fa fa-check" class="p-button-warn"
            [disabled]="!isValidPassword()" tabindex="4" (debounceClick)="updatePassword()" appDebounceClick
            label="{{'UserPrefs.password.apply' | translate }}"></button>
        </div>
      </form>
    </div>
  </div>
</p-panel>